// Showcase
// import show1 from '../assets/final/show/show1.webp';
const show1 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/show/show1.webp';
// import show5 from '../assets/final/show/show5.webp';
const show5 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597902/oak-and-stone-remodel/show/show5.webp';
// import show6 from '../assets/final/show/show6.webp';
const show6 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597903/oak-and-stone-remodel/show/show6.webp';
// import show7 from '../assets/final/show/show7.webp';
const show7 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597904/oak-and-stone-remodel/show/show7.webp';
// import show8 from '../assets/final/show/show8.webp';
const show8 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597904/oak-and-stone-remodel/show/show8.webp';
// import show9 from '../assets/final/show/show9.webp';
const show9 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597905/oak-and-stone-remodel/show/show9.webp';
// import show10 from '../assets/final/show/show10.webp';
const show10 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597872/oak-and-stone-remodel/show/show10.webp';
// import show11 from '../assets/final/show/show11.webp';
const show11 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597873/oak-and-stone-remodel/show/show11.webp';
// import show12 from '../assets/final/show/show12.webp';
const show12 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597873/oak-and-stone-remodel/show/show12.webp';
// import show13 from '../assets/final/show/show13.webp';
const show13 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597875/oak-and-stone-remodel/show/show13.webp';
// import show14 from '../assets/final/show/show14.webp';
const show14 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597877/oak-and-stone-remodel/show/show14.webp';
// import show16 from '../assets/final/show/show16.webp';
const show16 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597878/oak-and-stone-remodel/show/show16.webp';
// import show17 from '../assets/final/show/show17.webp';
const show17 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597878/oak-and-stone-remodel/show/show17.webp';
// import show18 from '../assets/final/show/show18.webp';
const show18 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597879/oak-and-stone-remodel/show/show18.webp';
// import show19 from '../assets/final/show/show19.webp';
const show19 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597880/oak-and-stone-remodel/show/show19.webp';
// import show20 from '../assets/final/show/show20.webp';
const show20 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597881/oak-and-stone-remodel/show/show20.webp';
// import show21 from '../assets/final/show/show21.webp';
const show21 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597882/oak-and-stone-remodel/show/show21.webp';
// import show22 from '../assets/final/show/show22.webp';
const show22 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597883/oak-and-stone-remodel/show/show22.webp';
// import show23 from '../assets/final/show/show23.webp';
const show23 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597884/oak-and-stone-remodel/show/show23.webp';
// import show24 from '../assets/final/show/show24.webp';
const show24 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597884/oak-and-stone-remodel/show/show24.webp';
// import show25 from '../assets/final/show/show25.webp';
const show25 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597885/oak-and-stone-remodel/show/show25.webp';
// import show26 from '../assets/final/show/show26.webp';
const show26 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597886/oak-and-stone-remodel/show/show26.webp';
// import show28 from '../assets/final/show/show28.webp';
const show28 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597887/oak-and-stone-remodel/show/show28.webp';
// import show29 from '../assets/final/show/show29.webp';
const show29 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597888/oak-and-stone-remodel/show/show29.webp';
// import show30 from '../assets/final/show/show30.webp';
const show30 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597889/oak-and-stone-remodel/show/show30.webp';
// import show31 from '../assets/final/show/show31.webp';
const show31 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597890/oak-and-stone-remodel/show/show31.webp';
// import show33 from '../assets/final/show/show33.webp';
const show33 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597891/oak-and-stone-remodel/show/show33.webp';
// import show34 from '../assets/final/show/show34.webp';
const show34 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597892/oak-and-stone-remodel/show/show34.webp';
// import show35 from '../assets/final/show/show35.webp';
const show35 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597893/oak-and-stone-remodel/show/show35.webp';
// import show36 from '../assets/final/show/show36.webp';
const show36 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597894/oak-and-stone-remodel/show/show36.webp';
// import show37 from '../assets/final/show/show37.webp';
const show37 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597895/oak-and-stone-remodel/show/show37.webp';
// import show38 from '../assets/final/show/show38.webp';
const show38 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597896/oak-and-stone-remodel/show/show38.webp';
// import show39 from '../assets/final/show/show39.webp';
const show39 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597897/oak-and-stone-remodel/show/show39.webp';
// import show40 from '../assets/final/show/show40.webp';
const show40 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597898/oak-and-stone-remodel/show/show40.webp';
// import show41 from '../assets/final/show/show41.webp';
const show41 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597899/oak-and-stone-remodel/show/show41.webp';
// import show42 from '../assets/final/show/show42.webp';
const show42 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597900/oak-and-stone-remodel/show/show42.webp';
// import show43 from '../assets/final/show/show43.webp';
const show43 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597901/oak-and-stone-remodel/show/show43.webp';

// kitchen
// import kitchen1 from '../assets/final/kitchen/kitchen1.webp';
const kitchen1 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597788/oak-and-stone-remodel/kitchen/kitchen1.webp';
// import kitchen2 from '../assets/final/kitchen/kitchen2.webp';
const kitchen2 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597800/oak-and-stone-remodel/kitchen/kitchen2.webp';
// import kitchen3 from '../assets/final/kitchen/kitchen3.webp';
const kitchen3 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597809/oak-and-stone-remodel/kitchen/kitchen3.webp';
// import kitchen4 from '../assets/final/kitchen/kitchen4.webp';
const kitchen4 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597817/oak-and-stone-remodel/kitchen/kitchen4.webp';
// import kitchen5 from '../assets/final/kitchen/kitchen5.webp';
const kitchen5 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597818/oak-and-stone-remodel/kitchen/kitchen5.webp';
// import kitchen6 from '../assets/final/kitchen/kitchen6.webp';
const kitchen6 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597818/oak-and-stone-remodel/kitchen/kitchen6.webp';
// import kitchen7 from '../assets/final/kitchen/kitchen7.webp';
const kitchen7 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597819/oak-and-stone-remodel/kitchen/kitchen7.webp';
// import kitchen8 from '../assets/final/kitchen/kitchen8.webp';
const kitchen8 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597820/oak-and-stone-remodel/kitchen/kitchen8.webp';
// import kitchen9 from '../assets/final/kitchen/kitchen9.webp';
const kitchen9 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597821/oak-and-stone-remodel/kitchen/kitchen9.webp';
// import kitchen10 from '../assets/final/kitchen/kitchen10.webp';
const kitchen10 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597789/oak-and-stone-remodel/kitchen/kitchen10.webp';
// import kitchen11 from '../assets/final/kitchen/kitchen11.webp';
const kitchen11 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597790/oak-and-stone-remodel/kitchen/kitchen11.webp';
// import kitchen12 from '../assets/final/kitchen/kitchen12.webp';
const kitchen12 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597791/oak-and-stone-remodel/kitchen/kitchen12.webp';
// import kitchen13 from '../assets/final/kitchen/kitchen13.webp';
const kitchen13 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597792/oak-and-stone-remodel/kitchen/kitchen13.webp';
// import kitchen14 from '../assets/final/kitchen/kitchen14.webp';
const kitchen14 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597793/oak-and-stone-remodel/kitchen/kitchen14.webp';
// import kitchen15 from '../assets/final/kitchen/kitchen15.webp';
const kitchen15 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597794/oak-and-stone-remodel/kitchen/kitchen15.webp';
// import kitchen16 from '../assets/final/kitchen/kitchen16.webp';
const kitchen16 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597795/oak-and-stone-remodel/kitchen/kitchen16.webp';
// import kitchen17 from '../assets/final/kitchen/kitchen17.webp';
const kitchen17 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597797/oak-and-stone-remodel/kitchen/kitchen17.webp';
// import kitchen18 from '../assets/final/kitchen/kitchen18.webp';
const kitchen18 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597798/oak-and-stone-remodel/kitchen/kitchen18.webp';
// import kitchen19 from '../assets/final/kitchen/kitchen19.webp';
const kitchen19 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597799/oak-and-stone-remodel/kitchen/kitchen19.webp';
// import kitchen20 from '../assets/final/kitchen/kitchen20.webp';
const kitchen20 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597801/oak-and-stone-remodel/kitchen/kitchen20.webp';
// import kitchen21 from '../assets/final/kitchen/kitchen21.webp';
const kitchen21 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597802/oak-and-stone-remodel/kitchen/kitchen21.webp';
// import kitchen22 from '../assets/final/kitchen/kitchen22.webp';
const kitchen22 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597802/oak-and-stone-remodel/kitchen/kitchen22.webp';
// import kitchen23 from '../assets/final/kitchen/kitchen23.webp';
const kitchen23 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597803/oak-and-stone-remodel/kitchen/kitchen23.webp';
// import kitchen24 from '../assets/final/kitchen/kitchen24.webp';
const kitchen24 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597804/oak-and-stone-remodel/kitchen/kitchen24.webp';
// import kitchen25 from '../assets/final/kitchen/kitchen25.webp';
const kitchen25 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597805/oak-and-stone-remodel/kitchen/kitchen25.webp';
// import kitchen26 from '../assets/final/kitchen/kitchen26.webp';
const kitchen26 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597806/oak-and-stone-remodel/kitchen/kitchen26.webp';
// import kitchen27 from '../assets/final/kitchen/kitchen27.webp';
const kitchen27 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597807/oak-and-stone-remodel/kitchen/kitchen27.webp';
// import kitchen28 from '../assets/final/kitchen/kitchen28.webp';
const kitchen28 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597808/oak-and-stone-remodel/kitchen/kitchen28.webp';
// import kitchen29 from '../assets/final/kitchen/kitchen29.webp';
const kitchen29 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597809/oak-and-stone-remodel/kitchen/kitchen29.webp';
// import kitchen30 from '../assets/final/kitchen/kitchen30.webp';
const kitchen30 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597810/oak-and-stone-remodel/kitchen/kitchen30.webp';
// import kitchen31 from '../assets/final/kitchen/kitchen31.webp';
const kitchen31 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597812/oak-and-stone-remodel/kitchen/kitchen31.webp';
// import kitchen32 from '../assets/final/kitchen/kitchen32.webp';
const kitchen32 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597813/oak-and-stone-remodel/kitchen/kitchen32.webp';
// import kitchen33 from '../assets/final/kitchen/kitchen33.webp';
const kitchen33 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597815/oak-and-stone-remodel/kitchen/kitchen33.webp';
// import kitchen34 from '../assets/final/kitchen/kitchen34.webp';
const kitchen34 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597816/oak-and-stone-remodel/kitchen/kitchen34.webp';

// bath
// import bath1 from '../assets/final/bath/bath1.webp';
const bath1 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597760/oak-and-stone-remodel/bath/bath1.webp';
// import bath2 from '../assets/final/bath/bath2.webp';
const bath2 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597767/oak-and-stone-remodel/bath/bath2.webp';
// import bath3 from '../assets/final/bath/bath3.webp';
const bath3 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597767/oak-and-stone-remodel/bath/bath3.webp';
// import bath4 from '../assets/final/bath/bath4.webp';
const bath4 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597768/oak-and-stone-remodel/bath/bath4.webp';
// import bath5 from '../assets/final/bath/bath5.webp';
const bath5 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597769/oak-and-stone-remodel/bath/bath5.webp';
// import bath6 from '../assets/final/bath/bath6.webp';
const bath6 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597770/oak-and-stone-remodel/bath/bath6.webp';
// import bath7 from '../assets/final/bath/bath7.webp';
const bath7 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597771/oak-and-stone-remodel/bath/bath7.webp';
// import bath8 from '../assets/final/bath/bath8.webp';
const bath8 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597772/oak-and-stone-remodel/bath/bath8.webp';
// import bath9 from '../assets/final/bath/bath9.webp';
const bath9 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597773/oak-and-stone-remodel/bath/bath9.webp';
// import bath10 from '../assets/final/bath/bath10.webp';
const bath10 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597774/oak-and-stone-remodel/bath/bath10.webp';
// import bath11 from '../assets/final/bath/bath11.webp';
const bath11 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597775/oak-and-stone-remodel/bath/bath11.webp';
// import bath12 from '../assets/final/bath/bath12.webp';
const bath12 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597776/oak-and-stone-remodel/bath/bath12.webp';
// import bath13 from '../assets/final/bath/bath13.webp';
const bath13 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597777/oak-and-stone-remodel/bath/bath13.webp';
// import bath14 from '../assets/final/bath/bath14.webp';
const bath14 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597778/oak-and-stone-remodel/bath/bath14.webp';
// import bath15 from '../assets/final/bath/bath15.webp';
const bath15 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597779/oak-and-stone-remodel/bath/bath15.webp';

// wood
// import wood1 from '../assets/final/wood/wood1.webp';
const wood1 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597905/oak-and-stone-remodel/wood/wood1.webp';
// import wood2 from '../assets/final/wood/wood2.webp';
const wood2 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597906/oak-and-stone-remodel/wood/wood2.webp';
// import wood3 from '../assets/final/wood/wood3.webp';
const wood3 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597907/oak-and-stone-remodel/wood/wood3.webp';
// import wood4 from '../assets/final/wood/wood4.webp';
const wood4 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597908/oak-and-stone-remodel/wood/wood4.webp';
// import wood5 from '../assets/final/wood/wood5.webp';
const wood5 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597909/oak-and-stone-remodel/wood/wood5.webp';
// import wood6 from '../assets/final/wood/wood6.webp';
const wood6 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597910/oak-and-stone-remodel/wood/wood6.webp';
// import wood7 from '../assets/final/wood/wood7.webp';
const wood7 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597911/oak-and-stone-remodel/wood/wood7.webp';
// import wood8 from '../assets/final/wood/wood8.webp';
const wood8 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597912/oak-and-stone-remodel/wood/wood8.webp';
// import wood9 from '../assets/final/wood/wood9.webp';
const wood9 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597913/oak-and-stone-remodel/wood/wood9.webp';
// import wood10 from '../assets/final/wood/wood10.webp';
const wood10 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597914/oak-and-stone-remodel/wood/wood10.webp';
// import wood11 from '../assets/final/wood/wood11.webp';
const wood11 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597915/oak-and-stone-remodel/wood/wood11.webp';
// import wood12 from '../assets/final/wood/wood12.webp';
const wood12 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597916/oak-and-stone-remodel/wood/wood12.webp';
// import wood13 from '../assets/final/wood/wood13.webp';
const wood13 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597917/oak-and-stone-remodel/wood/wood13.webp';

// other
// import other1 from '../assets/final/other/other1.webp';
const other1 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597828/oak-and-stone-remodel/other/other1.webp';
// import other2 from '../assets/final/other/other2.webp';
const other2 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597829/oak-and-stone-remodel/other/other2.webp';
// import other3 from '../assets/final/other/other3.webp';
const other3 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597830/oak-and-stone-remodel/other/other3.webp';
// import other4 from '../assets/final/other/other4.webp';
const other4 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597831/oak-and-stone-remodel/other/other4.webp';
// import other7 from '../assets/final/other/other7.webp';
const other7 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597832/oak-and-stone-remodel/other/other7.webp';
// import other8 from '../assets/final/other/other8.webp';
const other8 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597833/oak-and-stone-remodel/other/other8.webp';
// import other9 from '../assets/final/other/other9.webp';
const other9 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597834/oak-and-stone-remodel/other/other9.webp';
// import other10 from '../assets/final/other/other10.webp';
const other10 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597835/oak-and-stone-remodel/other/other10.webp';
// import other11 from '../assets/final/other/other11.webp';
const other11 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597836/oak-and-stone-remodel/other/other11.webp';
// import other12 from '../assets/final/other/other12.webp';
const other12 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597837/oak-and-stone-remodel/other/other12.webp';
// import other13 from '../assets/final/other/other13.webp';
const other13 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597838/oak-and-stone-remodel/other/other13.webp';
// import other14 from '../assets/final/other/other14.webp';
const other14 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597839/oak-and-stone-remodel/other/other14.webp';
// import other15 from '../assets/final/other/other15.webp';
const other15 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597840/oak-and-stone-remodel/other/other15.webp';
// import other16 from '../assets/final/other/other16.webp';
const other16 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597841/oak-and-stone-remodel/other/other16.webp';
// import other17 from '../assets/final/other/other17.webp';
const other17 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597842/oak-and-stone-remodel/other/other17.webp';
// import other18 from '../assets/final/other/other18.webp';
const other18 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597843/oak-and-stone-remodel/other/other18.webp';
// import other19 from '../assets/final/other/other19.webp';
const other19 =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597844/oak-and-stone-remodel/other/other19.webp';

export const galleryData = [
  {
    title: 'Showcase',
    text: `See the remodeling work we've done recently —
    and contact Oak and Stone Construction when you're ready to begin the design and build process in your home!`,
    button: '',
    slug: 'showcase',
    imageCollection: [
      show20,
      show23,
      show35,
      show1,
      show10,
      show6,
      show5,
      show8,
      show13,
      show9,
      show11,
      show12,
      show7,
      show14,
      show16,
      show17,
      show19,
      show21,
      show22,
      show24,
      show25,
      show26,
      show28,
      show42,
      show30,
      show31,
      show33,
      show34,
      show36,
      show37,
      show41,
      show29,
      show38,
      show43,
      show18,
      show39,
      show40
    ]
  },
  {
    title: 'Kitchens',
    text: 'A kitchen remodel is a great way to give your home a new feel, as well as upgrade the value of your home. We can do a wide variety of cabinet, island, drawer, and custom configurations for your home.',
    button: 'View kitchen image gallery',
    slug: 'kitchen-remodels',
    imageCollection: [
      kitchen29,
      kitchen15,
      kitchen5,
      kitchen7,
      kitchen8,
      kitchen32,
      kitchen26,
      kitchen9,
      kitchen4,
      kitchen6,
      kitchen1,
      kitchen10,
      kitchen33,
      kitchen3,
      kitchen13,
      kitchen16,
      kitchen14,
      kitchen11,
      kitchen17,
      kitchen18,
      kitchen19,
      kitchen20,
      kitchen21,
      kitchen22,
      kitchen23,
      kitchen24,
      kitchen25,
      kitchen2,
      kitchen27,
      kitchen30,
      kitchen28,
      kitchen12,
      kitchen34,
      kitchen31
    ]
  },
  {
    title: 'Bathrooms',
    text: 'We consider ourselves top tier bathroom remodel designer builders. Steam showers, heated floors, Euro glass doors, and more.',
    button: 'View bathrooms image gallery',
    slug: 'bathroom-remodels',
    imageCollection: [
      bath10,
      bath8,
      bath14,
      bath7,
      bath3,
      bath4,
      bath5,
      bath1,
      bath6,
      bath9,
      bath11,
      bath12,
      bath15,
      bath2,
      bath13
    ]
  },
  {
    title: 'Custom Woodwork',
    text: 'We can custom make build ins, book cases, mantles, arches, false beams and more.',
    button: 'View custom woodwork image gallery',
    slug: 'custom-woodwork',
    imageCollection: [
      wood4,
      wood2,
      wood1,
      wood7,
      wood5,
      wood6,
      wood8,
      wood9,
      wood10,
      wood11,
      wood12,
      wood13,
      wood3
    ]
  },
  // {
  //   title: 'Whole House',
  //   text: 'Whether you're looking to remodel your entire home or start fresh with a custom-built house, we specialize in creating cohesive designs and delivering top-quality craftsmanship. From initial plans to the final touches, we ensure every detail aligns with your vision.',
  //   button: 'View whole house projects',
  //   slug: 'whole-house-projects',
  //   imageCollection: []
  // },
  {
    title: 'Other Projects',
    text: 'We can build pretty much anything you need.',
    button: 'View other projects image gallery',
    slug: 'other-projects',
    imageCollection: [
      other7,
      other10,
      other17,
      other4,
      other1,
      other8,
      other9,
      other11,
      other12,
      other2,
      other3,
      other13,
      other15,
      other16,
      other14,
      other18,
      other19
    ]
  }
];
